import React, { useCallback, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Upload } from 'antd'
import * as Icons from '@ant-design/icons'
import { getMatcher, useGlobalShortcut } from 'admin/lib/shortcuts'

export function OpenTicketButton({ onOpen }) {
  const ref = useRef()

  useGlobalShortcut(
    getMatcher({ group: 'File', name: 'Load Image' }, 'I', {
      ctrlOrCommand: true
    }),
    useCallback(() => {
      ref.current.click()
    }, [])
  )

  return (
    <Upload
      accept="image/*,application/pdf"
      beforeUpload={file => {
        onOpen(file)
        return false
      }}
      showUploadList={false}
    >
      <Button icon={<Icons.UploadOutlined />} ref={ref}>
        Open Ticket
      </Button>
    </Upload>
  )
}

OpenTicketButton.propTypes = {
  onOpen: PropTypes.func.isRequired
}
